module.exports = __webpack_public_path__ + "img/balai-pustaka.f3b44535.png";